import React from 'react'
import { render } from 'react-dom'
import './index.css';
import "./wensiteapp.scss";
import MainFrom from './mainFrom';
window.React = React;
render(
    <MainFrom  />,
  document.getElementById('root')
);